module.exports = __webpack_public_path__ + "pdf-cabecera.6cef9166299dfafd1ae8.png";


//////////////////
// WEBPACK FOOTER
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/assets/img/pdf/pdf-cabecera.png
// module id = ../../../../../src/assets/img/pdf/pdf-cabecera.png
// module chunks = main